/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanionItem } from '../../models/companion-item';

export interface TravelControllerGetCompanion$Params {
  id: number;
}

export function travelControllerGetCompanion(http: HttpClient, rootUrl: string, params: TravelControllerGetCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetCompanion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanionItem;
      }>;
    })
  );
}

travelControllerGetCompanion.PATH = '/travel/companion/{id}';
